import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TaskPaymentTypeEnum } from '@zaoblako/shared/modules/task/enum/task.payment.type.enum';

/**
 * Localised display names for {@link TaskPaymentTypeEnum} enumeration values
 * grouped by locales ({@link I18nLocalesEnum} values)
 */
export const TaskPaymentTypeEnumI18n: Record<I18nLocalesEnum, Record<TaskPaymentTypeEnum, string>> = {
  [I18nLocalesEnum.EN_US]: {
    [TaskPaymentTypeEnum.BANK]: 'Bank',
    [TaskPaymentTypeEnum.CASH]: 'Cash',
  },
  [I18nLocalesEnum.RU_RU]: {
    [TaskPaymentTypeEnum.BANK]: 'Безналичный',
    [TaskPaymentTypeEnum.CASH]: 'Наличный',
  },
};
